import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

class TD_TABBED_UI {

  constructor( block ) {
    this.init(block);
    this.watchForContentChanges();
  }

  init(block) {
    this.block = block;
    this.contentWrap = this.block.querySelector('.tabs__content_wrap');
    this.tabContainers = this.block.querySelectorAll('.tabs__inner');
    this.tabsList = this.block.querySelector('.tabs__nav');
    this.slider = null; // used for tab navigation on mobile

    this.InitMarkup();
    
    this.tabListTriggers = this.tabsList.querySelectorAll('button');
    
    this.setLayoutState();

    this.watchTabClicks();
  }

  setLayoutState() {
    this.block.classList.add('layout-desktop');
    this.block.classList.remove('layout-mobile');

    if(this.tabContainers.length > 0) {
      this.tabContainers.forEach( (tabContainer, index) => {
        tabContainer.classList.remove('active');
        this.tabListTriggers[index].setAttribute('aria-selected', 'false');
        const innerContent = tabContainer.querySelector('.tabs__inner_content');
        if(innerContent) {
          innerContent.style.display = null;
        }
      });

      this.tabContainers[0].classList.add('active');
      this.tabListTriggers[0].setAttribute('aria-selected', 'true');
    }  
  }

  InitMarkup() {
    if(this.slider){
      this.slider.destroy();
      this.slider = null;
    }

    this.tabsList.innerHTML = '';

    // Build the required splide markup
    this.tabsList.classList.add('splide');
    const splideTrack = document.createElement('div');
    splideTrack.classList.add('splide__track');
    const splideList = document.createElement('ul');
    splideList.classList.add('splide__list');
    this.tabsList.appendChild(splideTrack);
    splideTrack.appendChild(splideList);

    this.tabContainers.forEach( tabContainer => {
      const label = tabContainer.getAttribute('data-label');

      // Build the tab toggle list
      const tabItem = document.createElement('li');
      tabItem.classList.add('tabs__tab_item');
      tabItem.classList.add('splide__slide');
      const tabButton = document.createElement('button');
      tabButton.classList.add('tabs__tab_trigger');
      tabButton.classList.add('btn');
      tabButton.classList.add('btn__pill');
      tabButton.classList.add('btn__outlined');
      tabButton.setAttribute('aria-controls', tabContainer.id);
      tabButton.setAttribute('aria-selected', 'false');
      tabButton.setAttribute('role', 'tab');
      tabButton.innerHTML = label;
      tabItem.appendChild(tabButton);
      splideList.appendChild(tabItem);

      // Set the first tab as active
      if( this.tabContainers[0] === tabContainer ) {
        tabButton.setAttribute('aria-selected', 'true');
        tabButton.classList.add('active');
        tabContainer.classList.add('active');
      }
    });

    // Initialize Splide for mobile view
    this.slider = new Splide( this.tabsList, {
      type : 'slide',
      drag : 'free',
      snap : false,
      autoWidth : true,
      gap: '2rem',
      pagination: false,
      arrows: false,
    }).mount();
  }

  watchTabClicks() {
    const clickHandler = (e) => {
      const trigger = e.currentTarget;
      
      if( trigger.getAttribute('aria-selected') === 'true' ) {
        return;
      }

      // Remove active class from all tabs
      this.tabContainers.forEach( tabContainer => {
        tabContainer.classList.remove('active');
      });
      this.tabListTriggers.forEach( tab => {
        tab.setAttribute('aria-selected', 'false');
        tab.classList.remove('active');
      });

      // Add active class to the clicked tab
      const target = trigger.getAttribute('aria-controls');
      const targetTab = this.block.querySelector(`#${target}`);
      targetTab.classList.add('active');
      trigger.setAttribute('aria-selected', 'true');
      trigger.classList.add('active');

      // Move splide to active tab
      if(this.slider) {
        const index = Array.from(this.tabListTriggers).indexOf(trigger);
        this.slider.go(index);
      }
    }

    if(this.tabListTriggers.length > 0) {
      this.tabListTriggers.forEach( trigger => {
        trigger.removeEventListener('click', clickHandler);
        trigger.addEventListener('click', clickHandler);
      });
    }
  }

  watchForContentChanges() {
    // Watches for changes in the editor
    if(this.observer == undefined && document.body.classList.contains('wp-admin')) {
      this.observer = new MutationObserver((mutationsList, observer) => {
        let timeout = null;

        const reInitialize = () => {
          if(timeout){
            clearTimeout(timeout);
          }
          timeout = setTimeout(() => {
            this.init(this.block);
          }, 100);
        }

        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            console.log('Child nodes changed:', mutation);
            const nodes = mutation.addedNodes.length ? mutation.addedNodes : mutation.removedNodes;
            if(nodes.length) {
              for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                if(node.nodeType === 1 && node.classList.contains('wp-block-acf-tab-inner-container')) {
                  reInitialize();
                }
              }
            }
          }
          if (mutation.type === 'characterData') {
            console.log('Text content changed:', mutation);
            console.log(mutation.target.parentElement);
            if(mutation.target.parentElement.parentElement.classList.contains('tabs__accordion_trigger')) {
              reInitialize();
            }
          }
        }
      });

      this.observer.observe(this.block, {
        childList: true,       // watches for the addition or removal of child elements
        subtree: true,         // watches all descendants
        characterData: true,   // watches changes to text content
        attributes: false      // set to true if you want to monitor attribute changes too
      });
    }
  }
}

export const InitTabbedContainer = () => {
  const blocks = document.querySelectorAll('.tabs');

  if( blocks.length > 0 ) {
    blocks.forEach( block => {
      block.tabbedUI = new TD_TABBED_UI( block );
    });
  }
}

export const InitTabbedContainerEditor = () => {
  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    const initializeEditorBlock = function( $block ){
      const block = $block[0].querySelector('.tabs');
      if(!!block){
        // Allow time for inner blocks to load
        setTimeout(() => {
          block.tabbedUI = new TD_TABBED_UI( block );
        }, 100);
      }
    }

    window.acf.addAction( 'render_block_preview/type=tabbed-container', initializeEditorBlock );
  }
}